module.exports = __webpack_public_path__ + "static/media/assignCardLarge.afcfc0d8.svg";